
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerBoard as ObiBeaconTowerBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-board.js';
 
 
 

 
 export const ObiBeaconTowerBoard = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-board',
   elementClass: ObiBeaconTowerBoardElement,
   events: {
     
   }
  });
 
 